<template>
    <div class="skills-list">
        <ul class="skills" :class="skillDisplayed.length > 2 ? 'joy-mb-4' : 'joy-mb-1'">
            <template v-for="skillRating in skillDisplayed" :key="skillRating.id">
                <li class="joy-mb-5" :data-testid="`vetting-skill-ratings-edition-list-element__${skillRating.id}`">
                    <VJoyWrapper justify="space-between" no-margin v-bind="{rowGap: '12', wrap: 'nowrap'}">
                        {{ skillRating.label }}
                        <SkillRatingField
                            :rating="skillRating.rating"
                            data-testid="vetting-skill-ratings-edition-list-element-rating"
                            @update:rating="(value) => handleUpdateSkill(skillRating, value)"
                        />
                    </VJoyWrapper>
                </li>
            </template>
        </ul>
        <VJoyButton v-if="isCTAMoreVisible" variant="ghost" size="xsmall" @click="handleToggleFullView">
            {{ getCTAText }}
        </VJoyButton>
    </div>
</template>

<script setup lang="ts">
    import {computed} from '#imports';
    import {VJoyButton, VJoyWrapper} from '@maltjoy/core-vue';
    import type {RatedSkill} from '@api';
    import SkillRatingField from '~/components/admin-section-tabs/qualification/SkillRatingField.vue';
    import {useSkillRatingsField} from '~/composables/useSkillRatingsField';
    import type {IUpdateRatedSkill, NormalizedSkillRating} from './types/IUseSkillRatingsField';

    const props = defineProps<{
        skillRatings: RatedSkill[];
    }>();

    const emit = defineEmits<{
        (e: 'update:skillRatings', value: IUpdateRatedSkill): void;
    }>();

    const {skillDisplayed, updateRating, handleToggleFullView, getCTAText, isCTAMoreVisible} = useSkillRatingsField(
        computed(() => props.skillRatings),
    );

    function handleUpdateSkill(skillRating: NormalizedSkillRating, newRating: number | null): void {
        const updateResult = updateRating(skillRating, newRating);
        emit('update:skillRatings', updateResult);
    }
</script>

<style lang="scss" scoped>
    .skills {
        padding-left: 0;
        list-style: none;
        columns: 2;
        column-gap: 30px;
    }
</style>
